import { createBannersService } from './cms/banners/BannersService';
import { createQuickLinksService } from './cms/quickLinks/QuickLinksService';

export const bannersService = createBannersService();
export const quickLinksService = createQuickLinksService();
